import { render, staticRenderFns } from "./IndexUserNotBuildStat.vue?vue&type=template&id=12036a72&scoped=true&"
import script from "./IndexUserNotBuildStat.vue?vue&type=script&lang=js&"
export * from "./IndexUserNotBuildStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12036a72",
  null
  
)

export default component.exports